var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7V3H9c0-1.1-.9-2-2-2s-2 .9-2 2H1v4c1.1 0 2 .9 2 2s-.9 2-2 2v4h4c0-1.1.9-2 2-2s2 .9 2 2h4v-4c1.1 0 2-.9 2-2s-.9-2-2-2z",
    fill: "#797584"
  })));
}

export default SvgPuzzle;